import * as t from './action_types';
import { makeActionCreatorObjParam } from '@trumedianetworks/tmn-core-components/src/util/redux-helpers';
import { apiAction } from '../../api/store/actions';
import { actions as siteActions } from '../../site';
import { selectors as userSelectors } from '../../user';
import { actions as notificationActions } from '../../notification';
import { getRouter } from '../../routing/route-base';

const setUserAccountData = makeActionCreatorObjParam(t.SET_ACCOUNT_DATA, 'data');
const resetUserAccountData = makeActionCreatorObjParam(t.RESET_ACCOUNT_DATA);

export const setPasswordResetToken = makeActionCreatorObjParam(t.SET_RESET_PASSWORD_TOKEN, 'token');
export const clearPasswordResetToken = makeActionCreatorObjParam(t.CLEAR_RESET_PASSWORD_TOKEN);

export const pbtokenLogin = (token, sitename) => {
    const url = '/v2/api/account/token-login';
    const params = { token, sitename };
    return tokenLogin(params, url);
    //const params = { token, sitename };
    // return dispatch(
    //     apiAction({
    //         url: '/v2/api/account/token-login',
    //         method: 'POST',
    //         data: params,
    //         onSuccess: (data) => {
    //             dispatch(setUserAccountData({ data }));
    //             // force reload now that user is logged in, slightly hack-ish but keeps the rest of the login proc simple
    //             window.location.assign(`/${sitename}`);
    //         },
    //         onFailure: () => {
    //             console.log('Error occured with token login');
    //         },
    //         // todo label
    //         label: t.LOGIN,
    //     })
    // );
};

export const accessTokenLogin = (accessToken, sitename) => {
    const url = '/v2/api/account/access-token-login';
    const params = { accessToken, sitename };
    return tokenLogin(params, url);
    // const params = { token, sitename };
    // return dispatch(
    //     apiAction({
    //         url: '/v2/api/account/access-token-login',
    //         method: 'POST',
    //         data: params,
    //         onSuccess: (data) => {
    //             dispatch(setUserAccountData({ data }));
    //             // force reload now that user is logged in, slightly hack-ish but keeps the rest of the login proc simple
    //             window.location.assign(`/${sitename}`);
    //         },
    //         onFailure: () => {
    //             console.log('Error occured with token login');
    //         },
    //         // todo label
    //         label: t.LOGIN,
    //     })
    // );
};

const tokenLogin = (params, url) => (dispatch, getState) => {
    //const params = { token, sitename };
    return dispatch(
        apiAction({
            url,
            method: 'POST',
            data: params,
            onSuccess: (data) => {
                dispatch(setUserAccountData({ data }));
                // force reload now that user is logged in, slightly hack-ish but keeps the rest of the login proc simple
                window.location.assign(`/${sitename}`);
            },
            onFailure: () => {
                console.log('Error occured with token login');
            },
            // todo label
            label: t.LOGIN,
        })
    );
};

export const fetchUserAccount = () =>
    apiAction({
        url: '/v2/api/account/validate-session',
        method: 'GET',
        onSuccess: (data) => setUserAccountData({ data }),
        onFailure: () => {
            // console.log('Error occured loading userData');
        },
        label: t.FETCH_ACCOUNT_DATA,
    });

export const login = (username, password, sitename) => (dispatch, getState) => {
    const params = { username, password, sitename };
    // if sucessful and we're on login or reset pw, we need to redirect to home
    return dispatch(
        apiAction({
            url: '/v2/api/account/login',
            method: 'POST',
            data: params,
            onSuccess: (data) => {
                dispatch(setUserAccountData({ data }));
                const router = getRouter();
                const currentLocation = router.getCurrentLocation();
                const routeIsLoginRoute =
                    currentLocation?.url.startsWith('login') ||
                    currentLocation?.url.startsWith('reset-password');
                if (routeIsLoginRoute) {
                    router.navigateByName('home');
                }
            },
            onFailure: (err) => {
                //console.log('Error with login', err);
            },
            label: t.LOGIN,
        })
    );
};

export const logout = () => (dispatch, getState) => {
    const activeAuthSite = userSelectors.activeAuthSiteNameSelector(getState());
    dispatch(siteActions.resetSiteData());
    return dispatch(
        apiAction({
            url: '/v2/api/account/logout',
            method: 'GET',
            onSuccess: (data) => {
                dispatch(resetUserAccountData());
                const redirPath = activeAuthSite ? `/${activeAuthSite}` : '/';
                window.location.assign(redirPath);
            },
            onFailure: (err) => {
                console.log('Error with logout', err);
            },
            label: t.LOGOUT,
        })
    );
};

export const requestResetAccountPassword = (username, sitename) => {
    const params = { username, sitename };
    return apiAction({
        url: '/v2/api/account/request-reset-password',
        method: 'POST',
        data: params,
        onSuccess: (data) =>
            notificationActions.showSnackbar({
                snackbarMessage: `Password reset email sent.`,
                snackbarType: 'success',
            }),
        onFailure: (err) => {
            if (err?.response?.data?.message) {
                return notificationActions.showSnackbar({
                    snackbarMessage: `Error: ${err?.response?.data?.message}`,
                    snackbarType: 'error',
                });
            }

            return notificationActions.showSnackbar({
                snackbarMessage: `Password reset failed.`,
                snackbarType: 'error',
            });
        },
        label: t.REQUEST_RESET_PASSWORD,
    });
};

export const resetAccountPassword =
    ({ authSite, token, password }) =>
    (dispatch, getState) => {
        const params = { token, password, sitename: authSite };
        return dispatch(
            apiAction({
                url: '/api/resetPW',
                method: 'POST',
                data: params,
                onSuccess: (data) => {
                    const message = data.message || 'You may now login with your new password';
                    dispatch(clearPasswordResetToken());
                    dispatch(
                        notificationActions.showSnackbar({
                            snackbarMessage: message,
                            snackbarType: 'success',
                            snackbarTime: 5000,
                        })
                    );
                    const router = getRouter();
                    // todo here I think is why the post-reset pw site doesn't quite go to the right page
                    router.navigateByName('login-site', { authSite });
                },
                onFailure: (err) => {
                    if (err?.response?.data?.message) {
                        return notificationActions.showSnackbar({
                            snackbarMessage: `Error: ${err?.response?.data?.message}`,
                            snackbarType: 'error',
                        });
                    }

                    return notificationActions.showSnackbar({
                        snackbarMessage: `Password reset failed.`,
                        snackbarType: 'error',
                    });
                },
                label: t.RESET_PASSWORD,
            })
        );
    };
